import React, { useState, useEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";

import { API } from "./utility/Api";
import { UseToast } from "./components/context/ToastContext";
import Navbar from "./components/Navbar/Navbar";
import FlagError from "./components/Shared/Error/FlagError";
import Unauthenticated from "./components/unAuthenticated/Unauthenticated";
import Authenticating from "./components/Authenticating/Authenticating";
import NavigationRoutes from "./helpers/Routes/NavigationRoutes";
import { camelToTitle, errorHandler } from "./helpers/helpers";
import { getLocationKey } from "./constants/constants";
import styles from "./App.module.css";

const App = () => {
  //eslint-disable-next-line
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const {
    setMainMessage,
    mainMessage,
    setLicenceInfo,
    setAppNames,
    setAppRegions,
    setAppTypes,
  } = UseToast();
  const [isAuth, setIsAuth] = useState("isAuthenticating");
  const [displayPostInstall, setDisplayPostInstall] = useState(false);
  const isLicenceActive = searchParams.get("lic");

  useEffect(() => {
    const Jiratoken = searchParams.get("jwt");
    const AuthenticateReactapp = async (token) => {
      await API.post(
        `reactAppAuth`,
        {
          token: Jiratoken,
          location: getLocationKey(
            camelToTitle(location.pathname.replace("/", ""))
          ),
        },
        {
          headers: {
            Authorization: `JWT ${token}`,
          },
        }
      )
        .then(function (response) {
          setIsAuth("Authenticated");
          setLicenceInfo(response.data.revyzLicence);
          setMainMessage("");
          setAppRegions(response.data.revyzRegions);
          setAppNames(response.data.revyzApps);
          setAppTypes(response.data.revyzAppTypes);
        })
        .catch(function (error) {
          setIsAuth("WrongAuth");
          const data = errorHandler(error);
          setMainMessage({ appearance: "error", text: data.message });
        });
    };

    if (
      process.env.REACT_APP_CUSTOM_NODE_ENV === "local" ||
      process.env.REACT_APP_CUSTOM_NODE_ENV === "development" ||
      isLicenceActive === "active"
    ) {
      //eslint-disable-next-line
      AP.context.getToken(function (token) {
        AuthenticateReactapp(token);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return isAuth === "Authenticated" ? (
    <>
      <Navbar displayPostInstall={displayPostInstall} />
      {mainMessage && <FlagError setFlag={[1]} message={mainMessage} />}
      <div className={styles.appContainer}>
        <div className={styles.pageContainer}>
          <NavigationRoutes />
        </div>
      </div>
    </>
  ) : isAuth === "isAuthenticating" ? (
    <Authenticating />
  ) : (
    <Unauthenticated />
  );
};

export default App;
